<template>
  <div class="about">
    <div :class="`d-flex justify-center`">
      <h2>Box Open/Close.</h2>
    </div>
    <div v-if="!loggedIn">
      <NeedLogin></NeedLogin>
    </div>
    <div v-else>
      <v-stepper v-model="stepper" vertical>
        <v-stepper-step :complete="stepper > 1" step="1">
          Select Box
          <small>Boxes you have access to open/close</small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <SelectBoxForAdmin
            @box_changed="boxSelected"
            v-if="!commentIsSelected"
          ></SelectBoxForAdmin>
          <!-- <v-btn text> Cancel </v-btn> -->
        </v-stepper-content>

        <v-stepper-step :complete="stepper > 2" step="2">
          Select text from template
        </v-stepper-step>

        <v-stepper-content step="2">
          <SelectBoxCommentTemplate
            v-bind="post"
            @comment_changed="commentSelected"
            v-if="boxIsSelected"
          ></SelectBoxCommentTemplate>
          <!-- <v-row justify="space-around">
          <v-btn small rounded color="primary" :to="{ name: 'Events' }" justify="space-around">Cancel</v-btn>
          </v-row> -->
          <div></div>
        </v-stepper-content>

        <v-stepper-step :complete="stepper > 3" step="3">
          Open/Close Box
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-container fluid v-if="commentIsSelected" outlined>
            <v-textarea
              counter
              :label="commentAreaLabel"
              :rules="commentrules"
              auto-grow
              outlined
              rows="3"
              autofocus
              v-model="finalComment"
            ></v-textarea>
          </v-container>
          <v-row
            v-if="boxIsSelected && commentIsSelected"
            align="center"
            justify="space-around"
          >
            <v-btn v-if="box.IsOpen" color="primary" @click="execOpenClose"
              ><v-icon left>mdi-lock-open-variant-outline</v-icon>Close:
              {{ boxname }}</v-btn
            >
            <v-btn
              v-if="!box.IsOpen"
              color="primary"
              @click="execOpenClose"
              small
              ><v-icon left>mdi-lock-outline</v-icon>Open: {{ boxname }}</v-btn
            >
            <v-btn @click="stepper = 2" small
              ><v-icon small>mdi-chevron-double-left</v-icon></v-btn
            >
            <!-- <v-btn @click="stepper = 4">Next</v-btn> -->
            <!-- <v-btn :to="cancellink">Cancel</v-btn> -->
          </v-row>
          <div>.</div>
        </v-stepper-content>

        <v-stepper-step step="4"> Notify users </v-stepper-step>
        <v-stepper-content step="4">
          <v-text-field
            :value="execResponseText"
            label="Solo"
            solo
            readonly
          ></v-text-field>
          <ExecBoxOpenClose
            v-bind="postExec"
            @exec_response="onExecResponse"
            v-if="stepper == 4"
          ></ExecBoxOpenClose>
          <SendEventSms
            v-bind="postSendEventSms"
            v-if="boxActionExecuted"
          ></SendEventSms>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SelectBoxForAdmin from "@/components/airbox/SelectBoxForAdmin.vue";
import SelectBoxCommentTemplate from "@/components/airbox/SelectBoxCommentTemplate.vue";
import ExecBoxOpenClose from "@/components/airbox/ExecBoxOpenClose.vue";
import SendEventSms from "@/components/Admin/SendEventSms.vue";
import NeedLogin from "@/components/Admin/NeedLogin.vue";

export default {
  name: "Lsb",
  data() {
    return {
      startInput: 0,
      cookieToken: Number,
      cookieRegId: Number,
      regid: Number,
      ac: String,
      box: [],
      boxname: String,
      boxIsSelected: false,
      comment: [],
      commentname: String,
      commentIsSelected: false,
      commentAreaLabel: String,
      finalComment: String,
      post: {
        id: Number,
        text: String,
      },
      commentrules: [(v) => v.length <= 150 || "Max 25 characters"],
      cancellink: { to: "/airbox/0" },
      stepper: 1,
      postExec: {
        id: Number,
        text: String, //from view
        boxOpenOrClose: Boolean,
        commentText: String,
      },
      execResponse: [],
      execResponseText: String,
      postSendEventSms: {
        regId: Number,
        ac: String,
        selectedEventId: Number,
        selectedEventName: String,
        smsText: String,
        comment: String,
        boxOpenOrClose: Boolean,
      },
      boxActionExecuted: Boolean,
    };
  },
  created() {
    this.getCookies();
    this.box = null;
    this.boxname = "Box Not Selected";
    this.comment = null;
    this.commentname = "Select Comment...";
    this.execResponseText = "Nothing";
    this.boxActionExecuted = false;
  },
  methods: {
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      this.postSendEventSms.ac = this.cookieToken;
      this.postSendEventSms.regId = this.cookieRegId;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    boxSelected(boxSelected) {
      this.box = boxSelected;
      this.boxname = boxSelected.Event;
      this.boxIsSelected = true;
      if (boxSelected.IsOpen == true) {
        this.commentAreaLabel = "Close Text..";
      } else {
        this.commentAreaLabel = "Open Text..";
      }

      this.post.id = this.box.EventId;
      this.post.text = this.box.Event;
      this.postExec.id = this.box.EventId;
      this.postExec.text = this.box.Event;
      this.postExec.boxOpenOrClose = !this.box.IsOpen;
      this.postSendEventSms.selectedEventId = this.box.EventId;
      this.postSendEventSms.regId = Number(this.regid);
      this.postSendEventSms.selectedEventName = this.box.Event;
      this.postSendEventSms.boxOpenOrClose = !this.box.IsOpen;
      console.log("postSms", this.postSendEventSms);

      this.stepper = 2;
      //   this.key++;
      //   console.log("box:",this.box);
    },
    commentSelected(commentSelected) {
      this.comment = commentSelected;
      this.commentname = commentSelected.Name;
      this.commentIsSelected = true;
      this.finalComment = commentSelected.CommentTemplate;

      this.stepper = 3;
      //   console.log("comment:",this.comment);
    },
    execOpenClose() {
      this.postExec.commentText = this.finalComment;
      this.postSendEventSms.comment = this.finalComment;
      this.postSendEventSms.smsText = this.finalComment;
      this.stepper = 4;
    },
    onExecResponse(response) {
      this.execResponseText = response.ResultMsg;
      if (response.Result == 1) {
        this.boxActionExecuted = true;
      } else {
        this.boxActionExecuted = false;
      }
    },
    onSendEventSmsResponse(response) {
      this.execResponseText = response;
    },
  },
  components: {
    SelectBoxForAdmin,
    SelectBoxCommentTemplate,
    ExecBoxOpenClose,
    SendEventSms,
    // SelectBoxCommentTemplate: () => import("@/components/airbox/SelectBoxCommentTemplate.vue"), //Denne rendrer ved behov <div v-if..>
    NeedLogin,
  },
};
</script>